import { AxiosPromise } from 'axios';
import { client }       from '@/service/client';

export const getReportList = (): AxiosPromise => client.get('/x-axis-reports/data');

export const deleteReport = (reportUuid: string): AxiosPromise => client.delete(`/x-axis-reports/${reportUuid}`);
